import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditModule } from '../../../shared/modules/edit.module';
import { SharedModule } from '../../../shared/modules/shared.module';
import { NgDragDropModule } from 'ng-drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { SharedInputModule } from '../../../shared/modules/shared-input.module';
import { ProductFoldersModule } from '../../../features/product-folders/product-folders.module';
import { ShContextMenuModule } from 'ng2-right-click-menu';
import { ContractItemsComponent } from './contract-items.component';
import { DateModule } from '../../../shared/components/forms/input/date/date.module';
import { MatExpansionModule } from '@angular/material';
import { CommonPaginationModule } from '../../../shared/components/listing/common/common-pagiation.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    EditModule,
    SharedModule.forRoot(),
    NgDragDropModule.forRoot(),
    DragDropModule,
    SharedInputModule,
    ProductFoldersModule,
    ShContextMenuModule,
    DateModule,
    MatExpansionModule,
    CommonPaginationModule,
  ],
  exports: [
    ContractItemsComponent
  ],
  declarations: [
    ContractItemsComponent,
  ],
  entryComponents: [
    ContractItemsComponent
  ],
})
export class ContractItemsModule { }
